import type { CompetitorProduct, Product } from "@/graphql/codegen/graphql"

export const filterOutCurrentProduct = (
  products: Product[],
  competitorProducts: CompetitorProduct[],
  currentProductId: number
): {
  filteredProducts: Product[]
  filteredCompetitorProducts: CompetitorProduct[]
  isOnlyMember: boolean
} => {
  const filteredProducts = products.filter((p) => p.productId !== currentProductId)
  const filteredCompetitorProducts = competitorProducts

  const isOnlyMember = !filteredProducts.length && !filteredCompetitorProducts.length

  return {
    filteredProducts,
    filteredCompetitorProducts,
    isOnlyMember,
  }
}
